class DisabledContinueBtn
  constructor: (@container) ->
    @btn = @container.find('input[type=submit]')
    @radiobuttons = @container.find('input[name=card_model_type]')
    @checkChooseType()
    @radiobuttons.click =>
      @checkChooseType()

  checkChooseType: ->
    @btn.prop('disabled', !@radiobuttons.is(':checked'))

$(window).on "load", ->
  $("*[data-behavior=DisabledContinueBtn]").each ->
    new DisabledContinueBtn($(@))
